import React, {useCallback} from 'react';
import {usePlaidLink} from 'react-plaid-link';
import {Button} from "semantic-ui-react";

const Plaid = ({ setPlaidData, plaidLinkToken, plaidEnv, loading, strings }) => {
    const onSuccess = useCallback((_, metadata) => {
        setPlaidData(metadata)
    }, [setPlaidData]);

    const config = {
        token: plaidLinkToken,
        env: plaidEnv,
        onSuccess,
    };

    const { open, ready, loading: plaidLinkLoading } = usePlaidLink(config)

    return (
        <Button style={{fontWeight:"700", minWidth:"170px"}} primary basic onClick={open} disabled={!ready || plaidLinkLoading || !!loading}>
            {strings.addBankAccount}
        </Button>
    )
}
export default Plaid
